/* eslint-disable */
import React, { Component } from 'react';
import {Button, Grid, Header, Icon, Segment, Step} from "semantic-ui-react";
import InspectionContainer from "../../containers/inspection_container";
import Properties from "../properties";
import InspectionGeneralDetails from './general_details';
import AssignClerk from './assign_clerk';
import AdditionalDetails from './inspection_additional_details';
import moment from 'moment';

class CreateInspection extends Component {

    constructor(props) {
        super(props);
        this.state = {
            propertyDetails: undefined,
            propertyId: undefined,
            companyId: undefined,
            booking_requirements:undefined,
            agent_booking_requirements:undefined,
            inspectionDate: moment().format("YYYY-MM-DD"),
            step1: true,
            step2: false,
            step3: false,
            step4: false,
            step1Complete: false,
            step2Complete: false,
            step3Complete: false,
            step4Complete: false,
            userRole: undefined
        }
    }

    onPropertySelected = (propertyId, data) => {
        this.setState({
            propertyDetails: data,
            propertyId: propertyId,
            companyId: data['company_id'],
            booking_requirements:data["booking_requirements"],
            agent_booking_requirements:data["agent_booking_requirements"],
            step1: false,
            step2: true,
            step1Complete: true,
            otherReport:false
        });
    };
    setOtherReport = () =>{
        this.setState({otherReport:true})
    }
    onComplete = (inspectionDate,startTime,endTime) => {
        this.setState({inspectionDate: inspectionDate,startTime:startTime,endTime:endTime});
        if (this.state.userRole === "admin") {
            this.setState({step3: true, step2: false, step2Complete: true});
        }
        else {
            this.setState({step4: true, step2: false,step2Complete: true, step3Complete: true});
        }
    };
    onAdditionalStepComplete = () => {
        this.setState({step3: false, step4: true, step3Complete: true});
    };

    componentWillMount() {
        const userRole = JSON.parse(localStorage.getItem('user'))['role'];
        this.setState({userRole});
    }

    render() {
        return (<div>
            <div className="inspection-create-propertylist-table">
                <div className="pad-top" style={{paddingBottom:0}}>
                    <Header content="Create Inspection " size='large' textAlign='left'/>
                </div>
                <div style={{margin: "1% 0% 0% 0%"}}>
                    <Step.Group ordered widths={4} size='mini'>
                        <Step completed={this.state.step1Complete} active={this.state.step1} onClick={()=>{this.state.step2?this.setState({step2:false,step1:true,step1Complete:false}):null}}>
                            <Step.Content>
                                <Step.Title>Property Selection</Step.Title>
                            </Step.Content>
                        </Step>

                        <Step completed={this.state.step2Complete} active={this.state.step2}>
                            <Step.Content>
                                <Step.Title>General Details</Step.Title>
                            </Step.Content>
                        </Step>

                        {this.state.userRole === "admin" &&
                        <Step active={this.state.step3} completed={this.state.step3Complete}>
                            <Step.Content>
                                <Step.Title>Assign Clerk</Step.Title>
                            </Step.Content>
                        </Step>}

                        <Step active={this.state.step4}>
                            <Step.Content>
                                <Step.Title>Notes & Attachments</Step.Title>
                            </Step.Content>
                        </Step>
                    </Step.Group>
                </div>
                {this.state.propertyDetails && <Segment raised>
                    <Header as='h4'>
                        <span>{"Property Address: "+this.state.propertyDetails['full_address']}</span><br/>
                        <span>{"Company Name: "+this.state.propertyDetails['company_name']}</span>
                    </Header>
                    </Segment>}
                <Segment raised>
                    <Grid style={{marginTop: '0px'}} stackable>
                        <Grid.Row style={{paddingTop:'0'}}>
                            {this.state.step1 && <div className="nested-listing-container pad-bottom">
                                <Properties selectProperty="yes" onPropertySelected={this.onPropertySelected} userRole={this.state.userRole}/>
                            </div>}
                            {this.state.step2 &&
                            <InspectionGeneralDetails setOtherReport={this.setOtherReport} propertyId={this.state.propertyId} propertyDetails={this.state.propertyDetails} onComplete={this.onComplete}
                                    companyId={this.state.companyId} userRole={this.state.userRole} agent_booking_requirements={this.state.agent_booking_requirements}booking_requirements={ this.state.booking_requirements } />
                            }
                            {this.state.step3 && <div
                                className="nested-listing-container pad-all">
                                <div className="right-aligned"><Button primary onClick={() => {
                                    this.setState({step3: false, step4: true, step3Complete: true})
                                }}>Go Next <Icon name="right arrow"/></Button></div>
                                <AssignClerk companyId={this.state.companyId} date={this.state.inspectionDate} startTime={this.state.startTime} endTime={this.state.endTime} />
                            </div>}
                            {this.state.step4 &&
                            <AdditionalDetails  otherReport={this.state.otherReport}  onAdditonalStepComplete={this.onAdditionalStepComplete}/>}
                        </Grid.Row>
                    </Grid>
                </Segment>

            </div>
        </div>);
    }

}

export default InspectionContainer(CreateInspection);


// WEBPACK FOOTER //
// ./src/views/inspection/create_inspection.js